import { useState } from 'react';

import useStateHandler from '@/hooks/useStateHandler';
import GalleryService from '@/services/gallery.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import Loader from '@/shared-components/loader/Loader';
import Text from '@/shared-components/text/components/Text';

import './styles/SaveDraft.css';

export default function SaveDraft({ formState, setFormState, initialState, buttonFormat = false, onClose }) {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  // Destructure both stateHandler and cacheHandler from the useStateHandler hook
  const { stateHandler, cacheHandler } = useStateHandler();

  async function saveDraft() {
    setLoading(true);

    const { response, data } = await GalleryService.saveArtworkDraft(formState);

    if (response.ok) {
      setLoading(false);
      setSuccess(true);
      
      const temporalPopupData = { 
        text: "Draft saved successfully", 
        theme: true
      };
      if (buttonFormat) {
        temporalPopupData.type = "navbar-present";
      }
      
      stateHandler.set("temporalPopup", temporalPopupData);
      cacheHandler.triggerAction("ARTWORK_DRAFT_SAVED");
      setTimeout(() => setSuccess(false), 4000);

      setFormState(prevValue => {
        const nextState = {
          ...prevValue,
          ...(response.status === 201 ? { _id: data._id } : {}),
          initialDraftStatus: prevValue.draft_status,
        };
        initialState.current = nextState;
        return nextState;
      });
    } else {
      setLoading(false);
    }
  }

  // Handler for when the text (non-button format) is clicked
  const onTextClick = () => {
    saveDraft();
  };

  // Handler for when the ContinueButton is clicked in button format
  const onButtonClick = () => {
    saveDraft();
    onClose();
  };

  return (
    <>
      {
        !buttonFormat ? 
          <Text
            className={[`add-artwork-form__save-draft-button element-non-selectable 
              ${(!formState.artwork_about.artwork_title || loading || formState === initialState.current) ? "disabled" : ""}
              ${success ? "read-only" : ""}`].filter(Boolean).join(" ")}
            onClick={onTextClick}>
            {success === true ? "Saved!" : "Save"}
            {loading && <Loader inline className="add-artwork-form__save-draft-spinner" thin />}
          </Text>
          :
          <ContinueButton 
            className={`artwork-confirmation-dialog__save-draft-button`}
            loading={loading}
            onClick={onButtonClick}
          >
            {success === true ? "Saved!" : "Save"}
          </ContinueButton>
      }
    </>
  );
}
